import { render, staticRenderFns } from "./CompanyAuth.vue?vue&type=template&id=9cc5848c&scoped=true"
import script from "./CompanyAuth.vue?vue&type=script&lang=js"
export * from "./CompanyAuth.vue?vue&type=script&lang=js"
import style0 from "./CompanyAuth.vue?vue&type=style&index=0&id=9cc5848c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc5848c",
  null
  
)

export default component.exports